export default "__VITE_ASSET__hX$bP88a__"